import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useT } from "@/lib/i18n";

/**
 * Discreet RISE call-out for the bottom of relevant service pages.
 * RISE is positioned as a rare, reserved premium experience — surfaced only
 * inside the executive coaching journey, not in the main navigation.
 */
export default function RiseDiscreetCta() {
  const t = useT();
  return (
    <section data-testid="rise-discreet-cta" className="bg-paper-2 py-20 md:py-24">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="border-t border-ink/10 pt-12 md:pt-16 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-accent-pink mb-5">
              {t("services.rise.eyebrowDiscreet")}
            </p>
            <h3 className="display text-3xl md:text-4xl lg:text-5xl leading-tight text-ink max-w-2xl">
              {t("services.rise.titleDiscreet")}
            </h3>
            <p className="text-[15px] md:text-[16px] leading-relaxed text-ink/75 mt-6 max-w-2xl">
              {t("services.rise.ledeDiscreet")}
            </p>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link
              to="/rise"
              data-testid="rise-discreet-link"
              className="inline-flex items-center gap-2 group"
            >
              <span className="display text-[18px] md:text-[20px] text-brand-deep underline decoration-accent-pink underline-offset-[6px] decoration-2 group-hover:decoration-[3px] transition-all">
                {t("services.rise.discoverDiscreet")}
              </span>
              <ArrowUpRight
                size={20}
                className="text-accent-pink shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
